import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'epBadgeStatusDescColor',
    standalone: false
})
export class BadgeStatusDescColorPipe implements PipeTransform {
    transform(value: string): string {
        let desc = '';
        if (!value) {
            return null;
        }

        switch (value.toString().toUpperCase()) {
            case 'NEW':
            case 'IN PROCESS':
            case 'SUBMITTED':
                desc = 'info';
                break;
            case 'APPROVED':
            case 'POSTED':
            case 'ACCEPTED':
                desc = 'success';
                break;
            case 'SUSPENDED':
                desc = 'error';
                break;
            //default badge for Rejected and Voided
            default:
                return '';
        }

        return desc;
    }
}
